<template>
  <div>
    <BasePageHeader>
      <div>
        <BasePageHeading>Card saved</BasePageHeading>
      </div>
    </BasePageHeader>
    <BaseWrapper>
      <div
        v-if="state === states.READY"
        class="text-center"
        data-test="card-complete"
      >
        <h1 class="my-6 text-4xl font-bold">
          Thank you
        </h1>
        <p class="my-2">
          Your card is saved. Nothing has been charged; you pay once a month for the candidates whose results you unlock.
        </p>
        <div>
          <BaseButton
            variant="green"
            class="my-12"
            :to="{ name: 'client-assessments-list' }"
          >
            Return to your assessments
          </BaseButton>
        </div>
      </div>
      <div
        v-else-if="state === states.LOADING"
        class="text-center"
      >
        <Loader />
        <p class="mt-4">
          Saving your card
        </p>
      </div>
      <div
        v-else
        class="text-center"
        data-test="card-complete-error"
      >
        <p class="my-6">
          {{ errorMessage }}
        </p>
        <BaseButton :to="{ name: 'settings-payg-plan' }">
          Back to pricing
        </BaseButton>
      </div>
    </BaseWrapper>
  </div>
</template>

<script>
import Loader from '@components/Loader'

import candidateBillingApi from '@api/candidateBilling'
import states from '@api/states'
import { mapGetters } from 'vuex'
import { setupReturn } from '@utils/candidateBilling'

/**
 * Stripe returns here after a bank challenge on card setup. The SetupIntent
 * id and client secret in the URL are proven on the server before anything
 * is recorded; a refresh replays safely.
 */
export default {
  components: {
    Loader
  },

  data() {
    return {
      states,
      done: false,
      failed: false,
      errorMessage: 'The card was not saved. Nothing has been charged; you can try again from the pricing page.'
    }
  },

  computed: {
    ...mapGetters({
      billing: 'subscriptions/candidateBilling'
    }),

    state() {
      if (this.failed) {
        return states.ERROR
      }
      if (!this.done) {
        return states.LOADING
      }
      return states.READY
    }
  },

  mounted() {
    this.complete()
  },

  methods: {
    complete() {
      const returned = setupReturn(this.$route.query)
      if (!returned || returned.redirectStatus === 'failed') {
        this.failed = true
        return
      }
      this.$store.dispatch('subscriptions/getCandidateBilling')
        .then(billing => candidateBillingApi.completeSetup({
          setupIntentId: returned.setupIntentId,
          setupIntentClientSecret: returned.setupIntentClientSecret,
          currency: billing && billing.currency ? billing.currency : (this.$route.query.currency || 'USD')
        }))
        .then(() => this.$store.dispatch('subscriptions/getCandidateBilling'))
        .then(() => {
          this.done = true
        })
        .catch(() => {
          this.failed = true
        })
    }
  }
}
</script>
